// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".loading-label[data-v-eb7d750e]{text-align:center;margin-top:15px}", ""]);
// Exports
module.exports = exports;
